
export const downloadField = `
	downloadInfo {
		title,
		tag,
		"fileName": file.asset->originalFilename,
		"fileUrl": file.asset->url
	}
`;
